// extracted by mini-css-extract-plugin
module.exports = {"form":"form__3DZgW","contentContainer":"contentContainer__2qpeR","longTitle":"longTitle__3Jx4E","shortTitle":"shortTitle__2GziP"};